module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAYAAABfJS4tAAABJElEQVQ4ja3TvytGURzH8ReRFDFYZDNaDBaxkdHqL7AoQikDyaCI/PgLLEajYjBaKAaDRcqGYrGJ/Ojoqttxj+d5bj516p7v/X7efc4v/6QN7KDxv4BBa/jMxgk6Q7EOmzgtCZ3GYFR7wFj4mCgJXc4ljcd2WfBSAviC8Z+mWsELCegdBvKNtYDnE9BwRl1xcwxuRVsBdC4B3UVTUYoVrOMIt1nzVtQzWwB8w/1fy5vEWWS6zf2fKYA+YTi7t0mFrejFa2TuwxQ+ovolujNYRXDQagS4KIDuoyXnrQrcjJvEAb1jMXupeVUFDhopSPmM0YQ3Ca6P5sfYy82v0Y+Dv5JVkzioA484RHsFbzJxQ0EtXKUhXGXbUkoB3IPzkv5fz/hb+ALBnW8lDkFjcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/true.png
// module id = 7D7G
// module chunks = 1